//该文件用于创建vuex中最为核心的store
import router from '../router/router'
import Vuex from 'vuex'
import Vue from 'vue'

import tagsView from './tags-view'
//应用vuex插件
Vue.use(Vuex)

//创建并暴露store
export default new Vuex.Store({
  modules: {
    tagsView
  },
  state: {
    // 存储token
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    theme: '' + localStorage.getItem("theme"),
    header: '' + localStorage.getItem("header"),
    loading:false,
  },
  actions: {
    UPDATE_THEME({ commit }, val) {
      commit('updateTheme', val)
    },
    UPDATE_HEADER({ commit }, val) {
      commit('updateHeader', val)
    }
  },
  mutations: {
    // 修改token，并将token存入sessionStorage
    changeLogin(state, user) {
      state.token = user.token;
      localStorage.setItem('token', user.token);
    },
    updateTheme(state, val) {
      state.theme = val;
    },
    updateHeader(state, val) {
      state.header = val;
    },
    updateLoading(state, val){
      state.loading=val
    }
  }
})




// WEBPACK FOOTER //
// ./src/store/index.js